import type { ReactNode } from "react";
import { Theme, YStack } from "tamagui";

import { Logo } from "@/components";
import TemplatedDialogHeader, {
  type DialogProgress,
} from "./TemplatedDialogHeader";

type Variant = "subclinical" | "clinical";

export type TemplatedDialogContentProps = {
  children: ReactNode;
  onClose?: () => void;
  variant: Variant;
  showBackButton?: boolean;
  onBackPress?: () => void;
  backButtonDisabled?: boolean;
  hideCloseButton?: boolean;
  dataTrackingIdPrefix?: string;
  progress?: DialogProgress;
};

const TemplatedDialogContent = ({
  children,
  onClose,
  variant,
  showBackButton = false,
  onBackPress,
  backButtonDisabled = false,
  hideCloseButton,
  dataTrackingIdPrefix,
  progress,
}: TemplatedDialogContentProps) => {
  const isClinical = variant === "clinical";

  return (
    <Theme name={isClinical ? "clinic" : undefined}>
      <YStack flex={1} borderRadius="$150">
        <TemplatedDialogHeader
          onClose={onClose}
          showBackButton={showBackButton}
          onBackPress={onBackPress}
          backButtonDisabled={backButtonDisabled}
          hideCloseButton={hideCloseButton}
          dataTrackingIdPrefix={dataTrackingIdPrefix}
          progress={progress}
        >
          {isClinical ? (
            <Logo.MedicalGroup
              height="$200"
              $md={{ height: "$250" }}
              $lg={{ height: "$300" }}
              color="$textPrimary"
            />
          ) : (
            <Logo height="$250" $lg={{ height: "$275" }} />
          )}
        </TemplatedDialogHeader>
        {children}
      </YStack>
    </Theme>
  );
};

export default TemplatedDialogContent;
